import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import UserMessagePageGrid from "../../common/Messaging/UserMessageGridLayout";

const Messaging = ({userId}) => {
  return (
    <div style={{width: "100%", height: "100%" }}>
      <UserMessagePageGrid pageId={userId}/>
    </div>
  );
};

export default Messaging;
